import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import surveyepievidenceRepository from '@/shared/http/repositories/business/surveyepievidence'
import typenonconformityRepository from '@/shared/http/repositories/business/typenonconformity'
import VistoriaEpiRepository from '@/shared/http/repositories/business/surveyEquipment'
import Alerts from '@/components/forms/Alerts'
import surveyepitypenonconformityRepository from '@/shared/http/repositories/business/surveyepitypenonconformity'
import { loading } from '@/shared/utils/UIHelper'
import cabecalhoPng from '../../../../../../static/img/survey/sem-foto.png'

export default {
  name: 'modalepisurvey',
  components: {
    Alerts
  },
  data () {
    return {
      CA: '',
      imgVazio: cabecalhoPng,
      dataStatus: {
        Mensagem: '',
        value: false
      },
      modal: {
        Obs: false,
        ContinuarButton: true,
        conforme: false
      },
      changeModal: 0,
      notConfome: false,
      testeimg: [],
      detailsImg: null,
      baseImgCompleta: [],
      checekdAllImg: false,
      EquipamentoEdit: null,
      imgEqp: [],
      EditEquipamento: {
        ca: '',
        equipamento: '',
        marca: '',
        modelo: '',
        serie: '',
        lote: '',
        observacao: '',
        descricao: ''
      },
      Nothing: 'N/A',
      imgModal: null,
      disableButtonDowload: true,
      tipoIncorformidade: [],
      vistoriaEpiIncorformidade: [],
      VerificarConformidade: false
    }
  },
  methods: {
    updateVistoriaEpi () {
      const oldValue = {
        descricao: this.EditEquipamento.descricao,
        ca: this.EditEquipamento.ca,
        // equi: this.EditEquipamento.equipamento,
        marca: this.EditEquipamento.marca,
        lote: this.EditEquipamento.lote,
        serie: this.EditEquipamento.serie,
        modelo: this.EditEquipamento.modelo,
        obs: this.EditEquipamento.observacao
      }
      this.EquipamentoEdit.ca = this.EditEquipamento.ca === '' ? null : this.EditEquipamento.ca
      // this.EquipamentoEdit.epi.descricaoReduzida = this.EditEquipamento.equipamento === '' ? null : this.EditEquipamento.equipamento
      this.EquipamentoEdit.marca = this.EditEquipamento.marca === '' ? null : this.EditEquipamento.marca
      this.EquipamentoEdit.modelo = this.EditEquipamento.modelo === '' ? null : this.EditEquipamento.modelo
      this.EquipamentoEdit.lote = this.EditEquipamento.lote === '' ? null : this.EditEquipamento.lote
      this.EquipamentoEdit.observacao = this.EditEquipamento.observacao === '' ? null : this.EditEquipamento.observacao
      this.EquipamentoEdit.descricao = this.EditEquipamento.descricao === '' ? null : this.EditEquipamento.descricao
      this.EquipamentoEdit.serie = this.EditEquipamento.serie === '' ? null : this.EditEquipamento.serie
      loading.push()
      VistoriaEpiRepository.PutVistoriaAndApiEpi(this.EquipamentoEdit)
        .then(Response => {
          if (this.$refs.alert) {
            this.$refs.alert.ShowAlert('success', 'Equipamento alterador com sucesso!!')
          }
          loading.pop()
        })
        .catch(Error => {
          this.EquipamentoEdit.descricao = oldValue.descricao
          this.EquipamentoEdit.ca = oldValue.ca
          this.EquipamentoEdit.equipamento = oldValue.equi
          this.EquipamentoEdit.marca = oldValue.marca
          this.EquipamentoEdit.lote = oldValue.lote
          this.EquipamentoEdit.modelo = oldValue.modelo
          this.EquipamentoEdit.serie = oldValue.serie
          this.EquipamentoEdit.observacao = oldValue.obs
          if (this.$refs.alert) {
            this.$refs.alert.ShowAlert('warning', 'Não foi possivel alterar o equipamento!!')
          }
          loading.pop()
        })
    },
    showModal (obj) {
      this.imgEqp = []
      this.disableButtonDowload = true
      this.VerificarConformidade = !obj.conforme
      this.EquipamentoEdit = obj
      this.EditEquipamento.ca = obj.ca
      this.EditEquipamento.equipamento = obj.epi.descricaoReduzida
      this.EditEquipamento.descricao = obj.descricao
      this.EditEquipamento.marca = obj.marca
      this.EditEquipamento.modelo = obj.modelo
      this.EditEquipamento.serie = obj.serie
      this.EditEquipamento.lote = obj.lote
      this.EditEquipamento.observacao = obj.observacao

      this.getTipoIncofirmidade()
      this.getVistoriaEpiTipoIncoformidade(obj.id)
      this.clearModal()
      this.imgModal = null
      this.$refs['authmodal'].show()
      this.getImagem(obj.id)
    },
    setChangeModal (e) {
      this.changeModal = e
    },
    showDetailsImg (base64img) {
      this.imgModal = base64img
    },
    clearModal () {
      this.modal.Obs = false
      this.modal.ContinuarButton = true
      this.notConfome = false
      this.CA = ''
      this.changeModal = 0
    },
    verificarTipoIncoformidade (value) {
      let verificar = this.vistoriaEpiIncorformidade.filter((Element) => Element.tipoInconformidadeId === value)
      if (verificar.length > 0) return false
      return true
    },
    getVistoriaEpiTipoIncoformidade (id) {
      surveyepitypenonconformityRepository.GetByVistoriaEpi(id)
        .then(Response => {
          if (Response.data.data.length > 0) {
            this.vistoriaEpiIncorformidade = Response.data.data
          }
        })
        .catch(Error => this.onException(Error))
    },
    getImagem (Id) {
      loading.push()
      surveyepievidenceRepository.GetImgByVistoriaEpi(Id)
        .then(Response => {
          let obj = Response.data.data
          if (obj.length > 0) {
            this.imgModal = Response.data.data[0].midias.foto
            this.disableButtonDowload = false
            obj.forEach(Element => this.imgEqp.push(Element))
          }
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    SetCheckList () {
      this.modal.Obs = true
    },
    modalNotConform () {
      alert('NotConform')
    },
    modalConform () {
      this.changeModal = 1
    },
    conformer () {
      this.notConfome = false
      this.conforme = true
      this.modal.ContinuarButton = false
    },
    teste () {
      this.notConfome = true
    },
    getTipoIncofirmidade () {
      typenonconformityRepository.GetAll()
        .then(Response => {
          this.tipoIncorformidade = Response.data.data
        })
        .catch(Error => this.onException(Error))
    },
    DowloadImagemCheackList () {
      var imgInp = document.querySelectorAll('.imgInput')
      let allimg = []
      imgInp.forEach((element) => allimg.push(element.src.replace('data:image/jpeg;base64,', '')))
      var zip = new JSZip()
      var img = zip.folder('imagens')
      for (let i = 0; i < allimg.length; i++) {
        img.file('img' + i + '.jpg', allimg[i], {base64: true})
      }
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'img_equipamentos.zip')
      })
    },
    hideModal () {
      this.$refs['authmodal'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/components/modalepisurvey/modalepisurvey.js